import React from 'react';
import {time_reformat, isNull} from '../../../izUtils';
import env from "../../../env/src_config";

const listElement = (props) => {
    return (
        <tr data-id={props.element.publicationId}>
            <td/>
            <td onClick={props.showSinglePublished}>{props.element.publicationId}</td>
            <td onClick={props.showSinglePublished}>{props.element.caseNumber}</td>
            <td onClick={props.showSinglePublished}>{props.t('published.list.status.'+props.element.status)}</td>
            <td onClick={props.showSinglePublished}>{(env.is_development ? props.element.procedureTypeRelation.valueCode + ' - ' : '') + props.element.procedureTypeRelation.valueContent}</td>
            <td onClick={props.showSinglePublished}>{(env.is_development ? props.element.saleFormRelation.valueCode + ' - ' : '') + props.element.saleFormRelation.valueContent}</td>
            <td data-sort={props.element.publicationAt} onClick={props.showSinglePublished}>{time_reformat(props.element.publicationAt).join(' ')}</td>
            <td data-sort={props.element.saleStartAt} onClick={props.showSinglePublished}>{time_reformat(props.element.saleStartAt).join(' ')}</td>
            <td data-sort={props.element.saleEndAt} onClick={props.showSinglePublished}>{isNull(props.element.saleEndAt) ? '' : time_reformat(props.element.saleEndAt).join(' ')}</td>
            <td onClick={props.showSinglePublished}>{(env.is_development ? props.element.saleMethodRelation.valueCode + ' - ' : '') + props.element.saleMethodRelation.valueContent}</td>
        </tr>
    );
};

export default listElement;
